module.exports = __webpack_public_path__ + "static/media/image1.31901d11.png";